interface Props {
  activeIndex: number;
  totalSlides: number;
}

export default function PcProgressBar({ activeIndex, totalSlides }: Props) {
  return (
    <div className="w-40 h-1 bg-third-grey rounded-full relative">
      <div
        className="absolute top-0 left-0 h-full bg-black rounded-full"
        style={{ width: `${((activeIndex + 1) / totalSlides) * 100}%` }}
      ></div>
    </div>
  );
}
